<template>

  <div id="newSessionModal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("session.new.title") }}</h5>
          <button type="button" class="btn-close" @click="cancel()" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ $t("session.new.instructions") }}</p>
          <form @submit.prevent="">
            
            <div class="form-group mb-3">
              <label for="nameInput">{{ $t("session.new.nameLabel") }}</label>
              <input id="nameInput" type="text" class="form-control" :class="{ 'is-invalid': nameError}" v-model="session.name">      
              <div v-if="nameError" class="invalid-feedback">
                {{nameError}}
              </div>   
            </div>

            <div class="form-group mb-3">
              <label for="startDateInput">{{ $t("session.new.startDateLabel") }}</label>
              <input id="startDateInput" type="datetime-local" class="form-control" :class="{ 'is-invalid': startDateError}" v-model="session.startDate">      
              <div v-if="startDateError" class="invalid-feedback">
                {{startDateError}}
              </div>   
            </div>

            <div class="form-group mb-3">
              <label for="endDateInput">{{ $t("session.new.endDateLabel") }}</label>
              <input id="endDateInput" type="datetime-local" class="form-control" :class="{ 'is-invalid': endDateError}" v-model="session.endDate">      
              <div v-if="endDateError" class="invalid-feedback">
                {{endDateError}}
              </div>   
            </div>

            <div class="form-group mb-3">
              <label for="moduleInput">{{ $t("session.new.moduleLabel") }}</label>
              <select class="form-select form-select-sm"  v-model="session.module" :class="{ 'is-invalid': moduleError}">
                <option v-for="module in modules" v-bind:key="module.id" v-bind:value="module">{{ module.name }}</option>
              </select>
              <div v-if="moduleError" class="invalid-feedback">
                {{moduleError}}
              </div>   
            </div>

            
            <div v-if="error" class="alert alert-danger" role="alert">
              {{error}}
            </div>

            <div v-if="session.module" class="form-group mb-3">
              <label>{{ $t("session.new.template_custom_value_label") }}</label>
              <fieldset class="scheduler-border">
                
                <div v-for="(property, index) in session.module.properties" v-bind:key="index">
                  
                  <div class="form-outline mb-3" v-if="property.format == 'enum'">
                    <label>{{ property.label }}</label>
                    <select class="form-select form-select-sm"  v-model="session.data[property.id]">
                      <option v-for="(value, indexVal) in property.values" v-bind:key="indexVal" v-bind:value="value.value">{{ value.label }}</option>
                    </select>
                  </div>
                                    
                  <div class="form-outline mb-3" v-if="property.format == 'string'">
                    <label>{{ property.label }}</label>
                    <textarea class="form-control" rows="3" v-model="session.data[property.id]"></textarea>
                  </div>

                  <div class="form-check form-switch mb-3" v-if="property.format == 'boolean'">
                    <input class="form-check-input" type="checkbox" :id="property.id" v-model="session.data[property.id]">
                    <label class="form-check-label" :for="property.id">{{ property.label }}</label>
                  </div>
                  
                </div>
              </fieldset>
            </div>            


            
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cancel()">{{ $t("session.new.closeLabel") }}</button>
          <button type="button" class="btn btn-primary" @click="createSession()">{{ $t("session.new.createLabel") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {Modal} from 'bootstrap';
import $ from 'jquery'

import sessionService from '../../services/sessionService';
import moduleService from '../../services/moduleService';
import eventConfig from '@/configs/eventConfig';

const emptySession = {
      name: null,
      startDate: null,
      endDate: null,
      module: null,
      data: {}
     };

export default {
  name: 'SessionNewComponent',
  props: {
    action: Boolean
  },
  watch: 
  { 
    action: function() {
      if(this.action)
      {
        this.loadModules();
        
      }
    }
  },
  data: function () {
    return {
      session: emptySession,
      newModal: null,
      nameError: null,
      startDateError: null,
      endDateError: null,
      moduleError: null,
      error: null,
      modules: null
    }
  },
  components: {
    
  },
  mounted () {
    
    this.newModal = new Modal($('#newSessionModal'));
    
    this.eventDispatcher.on(eventConfig.UNAUTHORIZED, () => {
      this.cancel();
    });

  },
  methods: {
    loadModules()
    {
      moduleService.getList().then(
        response => {
          this.modules = response;
          this.openModal();
        },
        errors => {
          
        }
      );
      
    },
    cancel()
    {
      this.newModal.hide();
      this.$emit(eventConfig.CANCELED);
    },
    resetCurrentSession()
    {
      this.session = emptySession;
      
      this.nameError = null;
      this.startDateError = null;
      this.endDateError = null;
      this.moduleError = null;

      this.error = null;
    },
    openModal() {
      this.resetCurrentSession();
      this.newModal.show();
    },
    createSession() {
      
      this.startDateError = null;
      this.endDateError = null;
      this.nameError = null;
      this.moduleError = null;
      this.error = null;

      var session = JSON.parse(JSON.stringify(this.session));

      if(this.session.module)
      {
        session.module = this.session.module.id;
      }

      sessionService.create(session).then(
        response => {
          this.newModal.hide();
          this.$emit(eventConfig.CREATED);
        },
        errors => {
            this.parseErrors(errors.response.data);
        }
      );
      
    },
    parseErrors(data)
    {
      if(data.errors)
      {
        for(let error of data.errors)
        {
          
          switch(error.param)
          {
            case 'startDate':
              this.startDateError = (error.msg.msg_code) ? this.$t(error.msg.msg_code) : error.msg;
            break;
            case 'endDate':
              this.endDateError = (error.msg.msg_code) ? this.$t(error.msg.msg_code) : error.msg;
            break;
            case 'name':
              this.nameError = (error.msg.msg_code) ? this.$t(error.msg.msg_code) : error.msg;
            break;
            case 'module':
              this.moduleError = (error.msg.msg_code) ? this.$t(error.msg.msg_code) : error.msg;
            break;
          }
        }
      }else
      {
        this.error = (data.msg_code) ? this.$t(data.msg_code) : data.msg;
      }
    }
  }
}
</script>
<style scoped>
fieldset.scheduler-border {
    border: 1px solid #ced4da;
    padding: 20px;
    border-radius: 0.25rem;

}


</style>